import Component from 'vue-class-component';
import { FILE_TO_WRITE_OBJECT } from '@/courses/values/courses.values';
import { SECTION_TYPES } from '@/content/values/sections';
import { ISectionMaterialRequest } from '../interfaces/section-material-request.interface';
import { IDocumentObject } from '../interfaces/result-split-object.interface';
import { Mixins } from 'vue-property-decorator';
import { CourseToolsMixin } from './course-tools.mixin';
import KEYS from '@/values/keys';
import { Section } from '../models/section.model';
import i18n from '../../lang/i18n';

@Component({})
export class CourseCreateSplitObjectMixin extends Mixins(CourseToolsMixin) {

  setResource(payload: FormData, doc: any, resource: string): FormData {
    if(doc.data) {
      if(doc.data.edition) {
        payload.append(resource, null);
      } else {
        if(doc.type == FILE_TO_WRITE_OBJECT.FILE) {
          payload.append(resource, doc.data);
        } else {
          payload.append(resource, null);
        }
      }
    }
    return payload;
  }

  getDocumentToSave(data: IDocumentObject) {
    let document: any = { name: data.document.data.name };
    let isFile = data.document.type == FILE_TO_WRITE_OBJECT.FILE;
    document.type = isFile ? data.typePdf : data.typeMaterial;
    return document;
  }

  getDocumentSectionMaterial(result: IDocumentObject): ISectionMaterialRequest {
    let sectionMaterial = null;
    if(result.document.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL) {
      sectionMaterial = {
        sectionName: result.document.data.name,
        materialId: result.document.data.material.relatedContentId,
        startSection: result.document.data.start,
        endSection: result.document.data.end,
        displayType: result.document.data.displayType
      }
      if(result.previous) {
        if(result.previous.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL) {
          sectionMaterial.id = result.previous.data.sectionMaterial.id;
        }
      }
    }
    return sectionMaterial;
  }

  saveSplitObject(
    payload: FormData,
    parentId: number,
    courseId: number,
    classId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.$Courses.Store.createWriteObjectA({
        payload, courseId, parentId
      }).then(async (res) => {
        try {
          await this.refreshContent({sectionId: res.id, parentId , courseId , classId});
          resolve();
        } catch(err) {
          reject();
        }
      }).catch((error) => {
        this.triggerErrorModal(error);
        reject();
      });
    });
  }

  triggerErrorModal(error) {
    if(error.data && error.data.error === 'BAD_REQUEST') {
      const hasErrorCode = error.data.errors && error.data.errors.length > 0;
      if(hasErrorCode) {
        const code = error.data.errors[0].status;
        if(i18n.en.errors.codes[code]) {
          this.$EdModal.createMessageModal({
            title: this.$i18n.t('courses.errors.errorTitle'),
            body: this.$i18n.t(`errors.codes.${code}`),
            type: KEYS.EVENT_TYPES.DANGER
          });
          return;
        }
      }
    }
    this.setError();
  }

  setError() {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('courses.errors.errorTitle'),
      body: this.$i18n.t('courses.errors.errorSavingObject'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  getProblemForEdition(problem: Section, currentValue: any) {
    let document: any = {};
    if(problem.type == SECTION_TYPES.SPLIT_QUESTION_PDF.code) {
      document.type = FILE_TO_WRITE_OBJECT.FILE;
    } else if(problem.type == SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code) {
      document.type = FILE_TO_WRITE_OBJECT.COURSE_MATERIAL;
    } else {
      return currentValue;
    }
    document.data = {...problem, edition: true };
    return document;
  }

  getSolutionForEdition(solution: Section, currentValue: any) {
    let document: any = {};
    if(solution.type == SECTION_TYPES.SPLIT_SOLUTION_PDF.code) {
      document.type = FILE_TO_WRITE_OBJECT.FILE;
    } else if(solution.type == SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code) {
      document.type = FILE_TO_WRITE_OBJECT.COURSE_MATERIAL;
    } else {
      return currentValue;
    }
    document.data = {...solution, edition: true };
    return document;
  }

  getProblemSolutionForEdition(sections: Section[]) {
    let problem: any =  { type: FILE_TO_WRITE_OBJECT.FILE, data: null };
    let solution: any = { type: FILE_TO_WRITE_OBJECT.FILE, data: null };
    sections.forEach((s) => {
      problem = this.getProblemForEdition(s, problem);
      solution = this.getSolutionForEdition(s, solution);
    });
    return {
      problem,
      solution
    }
  }

  updateSplitObject(
    payload: FormData,
    parentId: number,
    courseId: number,
    classId: number,
    sectionId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.$Courses.Store.updateWriteObjectA({
        payload, courseId, parentId, sectionId
      }).then(async (res) => {
        try {
          await this.refreshContent({sectionId, parentId , courseId , classId});
          resolve();
        } catch(err) {
          reject();
        }
      }).catch((error) => {
        this.triggerErrorModal(error);
        reject();
      });
    });
  }

  refreshContent({sectionId, parentId , courseId, classId} :{sectionId: number, 
    parentId: number , courseId: number, classId: number}): Promise<void> {
    return new Promise((resolve, reject) => {
      this.goToRefreshSectionsTree({sectionId, parentId, courseId, classId}).then(() => {
        resolve();
      }).catch(() => {
        reject(); 
      });
    });
  }

}